import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Services } from "@/components/site/Services";
import { Safety } from "@/components/site/Safety";
import { WhyChoose } from "@/components/site/WhyChoose";
import { Reviews } from "@/components/site/Reviews";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { FAQ } from "@/components/site/FAQ";
import { QuoteForm } from "@/components/site/QuoteForm";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (id && id.length > 1) {
                const el = document.querySelector(id);
                if (el) {
                    e.preventDefault();
                    lenis.scrollTo(el, { offset: -96 });
                }
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return (
        <div
            data-testid="landing-page"
            className="relative min-h-screen bg-brand-bg text-brand-text"
        >
            <ServiceArea />
            <Header />
            <main className="relative">
                <Hero />
                <Marquee />
                <Services />
                <WhyChoose />
                <Safety />
                <Gallery />
                <Reviews />
                <About />
                <FAQ />
                <QuoteForm />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}
